import editorInstance from '@/lib/editor/editor';
export function higlightCaptionComponent() {
    const caption = document.querySelector('[data-amelement="caption"]');
    if (caption)
        editorInstance.ui.highlight(caption);
}
export function highlightSermonClip() {
    const videoClip = document.querySelector('[data-amelement="sermonclip"]');
    if (videoClip)
        editorInstance.ui.highlight(videoClip);
}
